import { useRef } from "react";
import { HashRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { isMobile, useMobileOrientation } from "react-device-detect";
import { ContentWrapper, StatusBarWrapper, MainLayoutWrapper, MainWrapper, SideBarWrapper, RouterWrapper, BigScreenLayoutWrapper, MainContentLayoutWrapper } from "./Main.styled";
import MainSideBar from "./components/sidebar/MainSideBar";
import UserManagement from "../user-management/UserManagement";
import MainStatusBar from "./components/status-bar/MainStatusBar";
import ScaleUtils from "../../util/ScaleUtils";
import UpdatePassword from "../user-profile/component/UpdatePassword";
import MessageServiceLoader from "../../services/message/MessageServiceLoader";
import SessionService from "../../services/session/SessionService";
import Dashboard from "../dashboard/Dashboard";
import TenantManagement from "../tenant-management/TenantManagement";
import TenantDevices from "../tenant-device/TenantDevices";

interface MainProps {

}

const Main: React.FC<MainProps> = (props)=> {
    // ref
    let bigScreenResizeListenerRef = useRef(null);

    // router
    let routes = [
        {
            path: '/',
            element: <Dashboard />,
        },
        {
            path: '/index.html',
            element: <Dashboard />,
        },
        {
            path: '/dashboard',
            element: <Dashboard />,
        },
        {
            path: '/tenant-management/*',
            element: <TenantManagement />,
        },
        {
            path: '/tenant-device',
            element: <TenantDevices />,
        },
        {
            path : '/user-management',
            element: <UserManagement />
        },
        {
            path: '/profile/update-password',
            element: <UpdatePassword />
        }
    ];

    // view port and scales
    let { isLandscape } = useMobileOrientation();

    function setViewPort() {
        let viewport = document.querySelector("meta[name=viewport]") as any;
        if (!viewport){
            // in case there is no view port meta tag creates one and add it to the head
            viewport=document.createElement('meta') as any;
            viewport.name = "viewport";
            document.getElementsByTagName('head')[0].appendChild(viewport);
        }
        
        const content = `width=device-width, initial-scale=${isLandscape ? '0.5' : '0.25'}, user-scalable=yes,shrink-to-fit=no`;
        // this is where the magic happens by changing the vewport meta tag
        viewport.setAttribute('content', content);
    }

    function setBigScreenScale(wrapperDom: HTMLElement) {
        if (wrapperDom == null) {
            if (bigScreenResizeListenerRef.current) {
                window.removeEventListener('resize', bigScreenResizeListenerRef.current);
                bigScreenResizeListenerRef.current = null;
            }
            return;
        }
        if (bigScreenResizeListenerRef.current==null) {
            let bigScreenResizeListener = (e)=> {
                setBigScreenScale(wrapperDom);
            };
            window.addEventListener('resize', bigScreenResizeListener);
            bigScreenResizeListenerRef.current = bigScreenResizeListener;
        }
        
        let browserZoomPercent = window.outerWidth / window.innerWidth * 100.0;
        let bestMatchBrowserZoomPercent = 0;
        let minDiffPercent = 100;
        for(let zoomPercent of [100, 50, 33.333, 25, 10]) {
            let roundPercent = Math.round(browserZoomPercent / zoomPercent) * zoomPercent;
            let diffPercent = Math.abs(roundPercent - browserZoomPercent);
            if (diffPercent < minDiffPercent) {
                minDiffPercent = diffPercent;
                bestMatchBrowserZoomPercent = roundPercent;
            }
        }
        let browserZoom = bestMatchBrowserZoomPercent / 100.0;
        let screenWidth = window.screen.width / browserZoom;
        let screenHeight = window.screen.height / browserZoom;

        let widthRatio = screenWidth / 1920;
        let heightRatio = screenHeight / 1080;
        let ratio = widthRatio > heightRatio ? heightRatio : widthRatio;
        wrapperDom.style.transform = `scale(${ratio})`;
        wrapperDom.style.transformOrigin = 'left top';
        ScaleUtils.setGlobalScale(ratio);
    }

    function disableSwipeBack() {
        window.history.pushState(null, null, window.location.href);
        window.addEventListener('popstate', function (event) {
            window.history.pushState(null, null, window.location.href);
        });
    }
    
    if (isMobile) {
        setViewPort();
        disableSwipeBack();
    }

    // render
    return (
        <HashRouter>
            <MainWrapper>
                <UserAccessRedirect />
                <MessageServiceLoader />
                <Routes>
                    <Route path="/*" element={
                        <MainLayoutWrapper>
                            <MainContentLayoutWrapper>
                                <SideBarWrapper>
                                    <MainSideBar />
                                </SideBarWrapper>

                                <ContentWrapper>
                                    <StatusBarWrapper>
                                        <MainStatusBar />
                                    </StatusBarWrapper>
                        
                                    <RouterWrapper>
                                        <Routes>
                                        {
                                            routes.map((route)=> {
                                                return (
                                                    <Route key={route.path} path={route.path} element={route.element}></Route>
                                                )
                                            })
                                        }
                                        </Routes>
                                    </RouterWrapper>
                                </ContentWrapper>
                            </MainContentLayoutWrapper>
                        </MainLayoutWrapper>
                    } />
                </Routes>
            </MainWrapper>
        </HashRouter>
    )
};

interface UserAccessRedirectProps {
    
}

let UserAccessRedirect: React.FC<UserAccessRedirectProps> = (props)=> {
    // users access control
    let navigate = useNavigate();
    let location = useLocation();

    let profile = SessionService.getInstance().getCurrentUserProfile();
    if (!profile.admin) {
        if (location.pathname.indexOf('/big-screen') != 0) {
            setTimeout(()=> {
                navigate("/big-screen/overview");
            });
        }
    };

    return <div style={{position: 'absolute', visibility: 'hidden', width: '0', height: '0'}}></div>
};

export default Main;
